import React from 'react';
import { makeConnect } from '../../infrastructure/components/mobx-extensions';
import { ManageEventTrackerViewModal } from './manage-event-tracker.viewmodel';

const EventTrackerContext = React.createContext<ManageEventTrackerViewModal>(null);
const connectEventTrackerVM = makeConnect(EventTrackerContext);

export { EventTrackerContext, connectEventTrackerVM };
